import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import useFetchInterviews from "../hooks/useFetchInterviews";
import useCreateInterview from "../hooks/useCreateInterview";
import "./AdminAllDomainQuestionsScreen.css";

export default function AdminAllDomainQuestionsScreen() {
    const { domainId, packId } = useParams();
    const navigate = useNavigate();

    const { interviews, loadingInterviews } = useFetchInterviews(domainId, packId);
    const { createInterview, creatingInterview, error } = useCreateInterview();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [interviewName, setInterviewName] = useState("");
    const [requirements, setRequirements] = useState("");
    const [isFree, setIsFree] = useState(false);
    const [orderId, setOrderId] = useState("");

    const handleBack = () => navigate(-1);

    const handleCreateInterview = async () => {

        if (!interviewName.trim() || !orderId.trim()) {
            alert("Please fill all required fields.");
            return;
        }

        const data = {
            name: interviewName,
            requirements,
            isFree,
            orderId,
        };

        const success = await createInterview(domainId, packId, data);
        if (success) {
            alert("✅ Interview created successfully!");
            setIsModalOpen(false);
            setInterviewName("");
            setRequirements("");
            setOrderId("");
        }
    };

    return (
        <div className="all-interviews-page">
            <div className="header-row">
                <h2>All Interviews</h2>
                <div>
                    <button className="create-btn" onClick={() => setIsModalOpen(true)}>
                        ➕ Create Interview
                    </button>
                    <button className="back-btn" onClick={handleBack}>
                        ← Back
                    </button>
                </div>
            </div>

            {loadingInterviews ? (
                <p className="info-text">Loading interviews...</p>
            ) : interviews.length === 0 ? (
                <p className="info-text">No interviews found.</p>
            ) : (
                <ul className="interview-list">
                    {interviews.map((i) => (
                        <li key={i.id} className="interview-item"
                            onClick={() =>
                                navigate(`/admin/domain/${domainId}/pack/${packId}/interview/${i.id}/category`)
                            }>
                            <div className="interview-content">
                                <strong className="interview-title">{i.name || "Untitled Interview"}</strong>
                                {i.requirements && (
                                    <p className="interview-requirements">
                                        <span>Requirements:</span> {i.requirements}
                                    </p>
                                )}
                                <p className="interview-order">Order: {i.orderId}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            )}

            {/* Modal Popup */}
            {isModalOpen && (
                <div className="overlay" onClick={() => setIsModalOpen(false)}>
                    <div className="add-interview-modal" onClick={(e) => e.stopPropagation()}>
                        <h3>Create New Interview</h3>

                        <input
                            type="text"
                            className="modal-input"
                            placeholder="Interview Name"
                            value={interviewName}
                            onChange={(e) => setInterviewName(e.target.value)}
                        />

                        <textarea
                            className="modal-input"
                            placeholder="Technical Requirements (e.g. Java, React, SQL)"
                            value={requirements}
                            onChange={(e) => setRequirements(e.target.value)}
                            rows={3}
                        />

                        <input
                            type="number"
                            className="modal-input"
                            placeholder="Enter Order ID (e.g. 1)"
                            value={orderId}
                            onChange={(e) => setOrderId(e.target.value)}
                        />

                        {/* Free/Paid Option */}
                        <div className="free-paid-options">
                            <label>
                                <input
                                    type="radio"
                                    name="isFree"
                                    value="paid"
                                    checked={!isFree}
                                    onChange={() => setIsFree(false)}
                                />
                                Paid
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="isFree"
                                    value="free"
                                    checked={isFree}
                                    onChange={() => setIsFree(true)}
                                />
                                Free
                            </label>
                        </div>

                        <button
                            className="modal-submit-btn"
                            onClick={handleCreateInterview}
                            disabled={creatingInterview}
                        >
                            {creatingInterview ? "Creating..." : "Create Interview"}
                        </button>

                        {error && <p className="error-text">{error}</p>}
                    </div>
                </div>
            )}
        </div>
    );
}
